var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#0A28AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6094 8.96973L13.8309 11.8385L10.6094 14.462",
    stroke: "#FFFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10938 16.2188H16.6406C16.9772 16.2188 17.25 16.4916 17.25 16.8281C17.25 17.1647 16.9772 17.4375 16.6406 17.4375H8.10938C7.77283 17.4375 7.5 17.1647 7.5 16.8281C7.5 16.4916 7.77283 16.2188 8.10938 16.2188ZM7.5 13.1719C7.5 13.1719 9.53119 11.1406 13.5936 7.07812L15.4219 8.90625C11.3594 12.9688 9.32812 15 9.32812 15C8.92833 15 8.31895 15 7.5 15C7.5 14.1533 7.5 13.544 7.5 13.1719ZM14.2031 6.46875L15.4217 5.25L17.25 7.07812L16.0306 8.2975L14.2031 6.46875Z",
    fill: "#0A28AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "res/media/edit.f9adf6186c25b6e256fdf6a2799aed97.svg";
export { ForwardRef as ReactComponent };